import { translationLivechat_da } from "./translationLivechat.da";
import { defineDashboardTranslations } from "./translationTypes";
import { translationLivechat_en } from "./translationLivechat.en";
import { translationLivechat_sv } from "./translationLivechat.sv";

export const translationLivechat = defineDashboardTranslations({
  da: translationLivechat_da,
  en: translationLivechat_en,
  sv: translationLivechat_sv,
});
